import { useEffect, useState } from "react";
import ContentCommentListTile from "../content-comment-list-tile";
import { useTranslations } from "@/lib/static-intl";
import Span from "@/components/ui/Span";

const PostCommentList = ({
  allPostComments,
  setAllPostComments,
  pinnedCommentId,
  setPinnedCommentId,
  setTotalComments,
  scrollToCommentSection,
  setCurrentCommentInReply,
  selectedPostInModal,
  triggerFullScreenImageSlider,
  triggerReportModal,
  openProfile,
  currentUserFollowing,
  setCurrentUserFollowing,
}) => {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");

  const [pinnedComments, setPinnedComments] = useState([]);
  const [unpinnedComments, setUnpinnedComments] = useState([]);

  useEffect(() => {
    setPinnedComments(
      allPostComments.filter((comment) => comment?.id === pinnedCommentId)
    );
    setUnpinnedComments(
      allPostComments.filter((comment) => comment?.id !== pinnedCommentId)
    );
  }, [allPostComments, pinnedCommentId]);

  return (
    <div className="w-full flex flex-col gap-5">
      {pinnedComments?.map((comment, index) => (
        <ContentCommentListTile
          isSticky
          openProfile={openProfile}
          comment={comment}
          key={comment?.id || index}
          selectedPostInModal={selectedPostInModal}
          setAllPostComments={setAllPostComments}
          setCurrentCommentInReply={setCurrentCommentInReply}
          setPinnedCommentId={setPinnedCommentId}
          scrollToCommentSection={scrollToCommentSection}
          setTotalComments={setTotalComments}
          triggerReportModal={triggerReportModal}
          triggerFullScreenImageSlider={triggerFullScreenImageSlider}
          currentUserFollowing={currentUserFollowing}
          setCurrentUserFollowing={setCurrentUserFollowing}
        />
      ))}
      {unpinnedComments?.map((comment, index) => (
        <ContentCommentListTile
          comment={comment}
          openProfile={openProfile}
          key={comment?.id || index}
          selectedPostInModal={selectedPostInModal}
          setAllPostComments={setAllPostComments}
          setCurrentCommentInReply={setCurrentCommentInReply}
          setPinnedCommentId={setPinnedCommentId}
          scrollToCommentSection={scrollToCommentSection}
          setTotalComments={setTotalComments}
          triggerReportModal={triggerReportModal}
          triggerFullScreenImageSlider={triggerFullScreenImageSlider}
          currentUserFollowing={currentUserFollowing}
          setCurrentUserFollowing={setCurrentUserFollowing}
        />
      ))}
      <Span className="text-center text-xs pt-5 pb-10 opacity-50 ">
        {explorePostDetailsT("the_end")}
      </Span>
    </div>
  );
};

export default PostCommentList;
